/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Load_ErrorInputs */

const en_blog_load_error = /** @type {(inputs: Blog_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not load blog posts.`)
};

const es_blog_load_error = /** @type {(inputs: Blog_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron cargar las entradas del blog.`)
};

const de_blog_load_error = /** @type {(inputs: Blog_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blogbeiträge konnten nicht geladen werden.`)
};

const zh_blog_load_error = /** @type {(inputs: Blog_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法加载博客文章。`)
};

const ar_blog_load_error = /** @type {(inputs: Blog_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعذّر تحميل تدوينات المدونة.`)
};

const fr_blog_load_error = /** @type {(inputs: Blog_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de charger les articles du blog.`)
};

const vi_blog_load_error = /** @type {(inputs: Blog_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thể tải bài blog.`)
};

const sw_blog_load_error = /** @type {(inputs: Blog_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haikuweza kupakia machapisho ya blogu.`)
};

const th_blog_load_error = /** @type {(inputs: Blog_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่สามารถโหลดบทความในบล็อกได้`)
};

const bs_blog_load_error = /** @type {(inputs: Blog_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nije moguće učitati blog postove.`)
};

const ja_blog_load_error = /** @type {(inputs: Blog_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブログ投稿をロードできませんでした。`)
};

const ko_blog_load_error = /** @type {(inputs: Blog_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`블로그 게시물을로드 할 수 없습니다.`)
};

const pt_blog_load_error = /** @type {(inputs: Blog_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar as publicações do blog.`)
};

const it_blog_load_error = /** @type {(inputs: Blog_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non poteva caricare post sul blog.`)
};

const sv_blog_load_error = /** @type {(inputs: Blog_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunde inte ladda blogginlägg.`)
};

const nl_blog_load_error = /** @type {(inputs: Blog_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kon blogberichten niet laden.`)
};

const da_blog_load_error = /** @type {(inputs: Blog_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke indlæse blogindlæg.`)
};

const nb_blog_load_error = /** @type {(inputs: Blog_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klarte ikke laste blogginnlegg.`)
};

const fi_blog_load_error = /** @type {(inputs: Blog_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blogikuormitusta ei voitu ladata.`)
};

const pl_blog_load_error = /** @type {(inputs: Blog_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie można wczytać blogów.`)
};

const ru_blog_load_error = /** @type {(inputs: Blog_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось загрузить посты в блоге.`)
};

const tr_blog_load_error = /** @type {(inputs: Blog_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog gönderilerini yükleyemez.`)
};

const hi_blog_load_error = /** @type {(inputs: Blog_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ब्लॉग पोस्ट लोड नहीं कर सका।`)
};

const id_blog_load_error = /** @type {(inputs: Blog_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak dapat memuat posting blog.`)
};

const ms_blog_load_error = /** @type {(inputs: Blog_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak dapat memuatkan hantaran blog.`)
};

const cs_blog_load_error = /** @type {(inputs: Blog_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nelze načíst příspěvky na blog.`)
};

const el_blog_load_error = /** @type {(inputs: Blog_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αδυναμία φόρτωσης δημοσιεύσεων blog.`)
};

const he_blog_load_error = /** @type {(inputs: Blog_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לא ניתן לטעון את פוסטי הבלוג.`)
};

const af_blog_load_error = /** @type {(inputs: Blog_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kon nie blogplasings laai nie.`)
};

const hu_blog_load_error = /** @type {(inputs: Blog_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem sikerült betölteni a blogbejegyzéseket.`)
};

/**
* | output |
* | --- |
* | "Could not load blog posts." |
*
* @param {Blog_Load_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const blog_load_error = /** @type {((inputs?: Blog_Load_ErrorInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Load_ErrorInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_blog_load_error(inputs)
	if (locale === "de") return de_blog_load_error(inputs)
	if (locale === "zh") return zh_blog_load_error(inputs)
	if (locale === "ar") return ar_blog_load_error(inputs)
	if (locale === "fr") return fr_blog_load_error(inputs)
	if (locale === "vi") return vi_blog_load_error(inputs)
	if (locale === "sw") return sw_blog_load_error(inputs)
	if (locale === "th") return th_blog_load_error(inputs)
	if (locale === "bs") return bs_blog_load_error(inputs)
	if (locale === "ja") return ja_blog_load_error(inputs)
	if (locale === "ko") return ko_blog_load_error(inputs)
	if (locale === "pt") return pt_blog_load_error(inputs)
	if (locale === "it") return it_blog_load_error(inputs)
	if (locale === "sv") return sv_blog_load_error(inputs)
	if (locale === "nl") return nl_blog_load_error(inputs)
	if (locale === "da") return da_blog_load_error(inputs)
	if (locale === "nb") return nb_blog_load_error(inputs)
	if (locale === "fi") return fi_blog_load_error(inputs)
	if (locale === "pl") return pl_blog_load_error(inputs)
	if (locale === "ru") return ru_blog_load_error(inputs)
	if (locale === "tr") return tr_blog_load_error(inputs)
	if (locale === "hi") return hi_blog_load_error(inputs)
	if (locale === "id") return id_blog_load_error(inputs)
	if (locale === "ms") return ms_blog_load_error(inputs)
	if (locale === "cs") return cs_blog_load_error(inputs)
	if (locale === "el") return el_blog_load_error(inputs)
	if (locale === "he") return he_blog_load_error(inputs)
	if (locale === "af") return af_blog_load_error(inputs)
	if (locale === "hu") return hu_blog_load_error(inputs)
	return en_blog_load_error(inputs)
});